const baseInfo = {
  BASE_TITLE: '苏州市广济医院',
  SERVICE_INTERCEPT: true,
  REQUEST_TIMEOUT: 30000,
  // BASE_URL: 'http://192.168.3.12:9095/'
  BASE_URL_PDF: 'http://www.szgjyy.cn:9096/reportPdf/HisReport/HisReportList?applyExaminationNo=',
  BASE_URL: 'http://www.szgjyy.cn/payment'
}
export default baseInfo
